import Navbar from "../components/Navbar";
import "../styles/Home.css";

export default function Services() {
  return (
    <>
    

      {/* Page Header */}

      <section className="section">
        <div className="container" style={{ textAlign: "center" }}>

          <h1 style={{ fontSize: "40px", marginBottom: "15px" }}>
            Our Services
          </h1>

          <p style={{ maxWidth: "700px", margin: "auto", color: "#555" }}>
            Scalable technology solutions designed to help businesses automate,
            grow, and build powerful digital systems.
          </p>

        </div>
      </section>

      {/* Services */}

      <section className="section">
        <div className="container">

          <div className="services">

            {/* Salesforce */}

            <div className="service-card">

              <h3>Salesforce Complete Solutions</h3>

              <p>
                End-to-end Salesforce services including Admin setup,
                Object configuration, Page Layouts, Profiles, Permission Sets,
                User Management, Flows, Automation, Apex Triggers,
                Lightning Web Components, Aura Components, API integrations,
                Salesforce-to-Salesforce integrations, and Website-to-Lead solutions.
              </p>

            </div>

            {/* React */}

            <div className="service-card">

              <h3>React JS & Custom Website Development</h3>

              <p>
                High-performance custom websites for businesses and enterprises.
                Modern UI/UX design, SPA architecture, REST API integrations,
                dashboards, admin panels, and scalable business platforms
                built using React JS.
              </p>

            </div>

            {/* Shopify */}

            <div className="service-card">

              <h3>Shopify Custom eCommerce Development</h3>

              <p>
                Complete Shopify store development including custom theme design,
                product page architecture, add-to-cart features, wishlist tools,
                compare products functionality, payment gateway integration,
                checkout setup, and full eCommerce optimization.
              </p>

            </div>

          </div>

        </div>
      </section>


      {/* Certifications */}

      <section className="section">
        <div className="container">

          <h2 className="section-title">
            Salesforce Certifications
          </h2>

          <div className="tech-stack">

            <div className="tech">Platform Developer I</div>
            <div className="tech">Platform Developer II</div>
            <div className="tech">Process Automation</div>
            <div className="tech">Security & Privacy</div>
            <div className="tech">AI Associate</div>
            <div className="tech">Agentforce Specialist</div>

          </div>

        </div>
      </section>


      {/* Footer */}

      <footer className="footer">
        <div className="container">

          <p>© 2024 AlmondSoftware. All rights reserved.</p>

          <p style={{ marginTop: "10px" }}>
            Engineering digital products with intelligence
          </p>

          <div className="socials">
            <a href="#">FB</a>
            <a href="#">TW</a>
            <a href="#">LI</a>
          </div>

        </div>
      </footer>

    </>
  );
}